"use strict";

exports.__esModule = true;
var _exportNames = {
  ActionHelper: true,
  JoinActionHelper: true,
  ReducerHelper: true,
  JoinReducerHelper: true,
  deepmerge: true,
  mapSchemaToState: true,
  mapFieldsToState: true,
  getAlertClassName: true,
  filterSchema: true,
  filterFields: true,
  filterVisible: true,
  filterGuarded: true,
  filterFilter: true,
  filterPreview: true,
  filterEditable: true,
  objectToArray: true,
  mapSchemaToColumns: true,
  mapSchemaToFields: true,
  paramsToString: true,
  mapFiltersToString: true,
  mapSortingParamsToString: true,
  formatFilesize: true,
  validateEmail: true,
  parseParamShorthands: true,
  mapShorthandToReadable: true,
  parseShorthandToDate: true,
  debounce: true,
  isValidJson: true,
  getRandomInt: true,
  capitalize: true,
  Csv: true,
  formatDurationToASP: true
};
exports.validateEmail = exports.parseShorthandToDate = exports.parseParamShorthands = exports.paramsToString = exports.objectToArray = exports.mapSortingParamsToString = exports.mapShorthandToReadable = exports.mapSchemaToState = exports.mapSchemaToFields = exports.mapSchemaToColumns = exports.mapFiltersToString = exports.mapFieldsToState = exports.isValidJson = exports.getRandomInt = exports.getAlertClassName = exports.formatFilesize = exports.formatDurationToASP = exports.filterVisible = exports.filterSchema = exports.filterPreview = exports.filterGuarded = exports.filterFilter = exports.filterFields = exports.filterEditable = exports.deepmerge = exports.debounce = exports.capitalize = exports.ReducerHelper = exports.JoinReducerHelper = exports.JoinActionHelper = exports.Csv = exports.ActionHelper = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _ActionHelper = _interopRequireDefault(require("./ActionHelper"));
exports.ActionHelper = _ActionHelper.default;
var _JoinActionHelper = _interopRequireDefault(require("./JoinActionHelper"));
exports.JoinActionHelper = _JoinActionHelper.default;
var _ReducerHelper = _interopRequireDefault(require("./ReducerHelper"));
exports.ReducerHelper = _ReducerHelper.default;
var _JoinReducerHelper = _interopRequireDefault(require("./JoinReducerHelper"));
exports.JoinReducerHelper = _JoinReducerHelper.default;
var _deepmerge = _interopRequireDefault(require("./deepmerge"));
exports.deepmerge = _deepmerge.default;
var _DateHelper = require("./DateHelper");
Object.keys(_DateHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DateHelper[key]) return;
  exports[key] = _DateHelper[key];
});
var _WebRequestHelper = require("./WebRequestHelper");
Object.keys(_WebRequestHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WebRequestHelper[key]) return;
  exports[key] = _WebRequestHelper[key];
});
var _TranslationHelper = require("./TranslationHelper");
Object.keys(_TranslationHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TranslationHelper[key]) return;
  exports[key] = _TranslationHelper[key];
});
var _SlateHtmlSerializer = require("./SlateHtmlSerializer");
Object.keys(_SlateHtmlSerializer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SlateHtmlSerializer[key]) return;
  exports[key] = _SlateHtmlSerializer[key];
});
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mapSchemaToState = schema => {
  const state = {};
  Object.entries(schema).map(entry => {
    state[entry[0]] = entry[1].value; //create switch to match types

    return true;
  });
  return state;
};
exports.mapSchemaToState = mapSchemaToState;
const mapFieldsToState = array => {
  const state = {};
  array.map(entry => {
    state[entry.key] = entry.value;
    return true;
  });
  return state;
};
exports.mapFieldsToState = mapFieldsToState;
const getAlertClassName = type => {
  switch (type) {
    case "error":
      return "alert-danger";
    case "success":
      return "alert-success";
    default:
      return "";
  }
};
exports.getAlertClassName = getAlertClassName;
const filterSchema = (object, options) => {
  return Object.entries(object).filter(([key, value]) => {
    return !options.some(option => value[option.key] === option.value);
  }).reduce((obj, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {});
};
exports.filterSchema = filterSchema;
const filterFields = (array, options) => {
  return array.filter(field => {
    return !options.some(option => field[option.key] === option.value);
  });
};
exports.filterFields = filterFields;
const filterVisible = array => {
  return array.filter(field => {
    if (field.visible === false) return false;
    return true;
  });
};
exports.filterVisible = filterVisible;
const filterGuarded = array => {
  return array.filter(field => {
    if (field.guarded === true) return false;
    if (field.unguarded === false) return false;
    return true;
  });
};
exports.filterGuarded = filterGuarded;
const filterFilter = array => {
  return array.filter(field => {
    if (field.filter === false) return false;
    return true;
  });
};
exports.filterFilter = filterFilter;
const filterPreview = array => {
  return array.filter(field => {
    if (field.preview !== true) return false;
    return true;
  });
};
exports.filterPreview = filterPreview;
const filterEditable = element => {
  if (element.editable === false) return false;
  return true;
};
exports.filterEditable = filterEditable;
const objectToArray = object => {
  return Object.entries(object).map(([key, value]) => {
    return {
      ...value,
      key
    };
  });
};
exports.objectToArray = objectToArray;
const mapSchemaToColumns = (schema, options = {}) => {
  options.filterVisible = options.filterVisible || true;
  options.filterGuarded = options.filterGuarded || false;
  let columns = objectToArray(schema);
  if (options.filterVisible) columns = filterVisible(columns);
  if (options.filterGuarded) columns = filterGuarded(columns);
  return columns;
};
exports.mapSchemaToColumns = mapSchemaToColumns;
const mapSchemaToFields = (schema, options = {}) => {
  options.filterVisible = options.filterVisible || true;
  options.filterGuarded = options.filterGuarded || false;
  let fields = objectToArray(schema);
  if (options.filterVisible) fields = filterVisible(fields);
  if (options.filterGuarded) fields = filterGuarded(fields);
  return {
    rows: fields
  };
};
exports.mapSchemaToFields = mapSchemaToFields;
const paramsToString = params => {
  if (!params) return "";
  const arr = Object.entries(params).map(([key, val]) => {
    if (!val) return undefined;
    return `${key}=${val}`;
  }).filter(a => typeof a !== "undefined");
  const str = arr.length ? "?" + arr.join("&") : "";
  return str;
};
exports.paramsToString = paramsToString;
const mapFiltersToString = filters => {
  const flat = filters.map(filter => {
    if (filter.type === "Date") {
      switch (filter.operator) {
        case "<":
          return `${filter.property} < ${filter.value}`;
        case "<=":
          return `${filter.property} < ${filter.value2}`;
        case "=":
          return `${filter.property} >= ${filter.value} and ${filter.property} <= ${filter.value2}`;
        case ">=":
          return `${filter.property} > ${filter.value}`;
        case ">":
          return `${filter.property} > ${filter.value2}`;
      }
    } else {
      switch (filter.operator) {
        /* Strings */

        case "Contains":
        case "StartsWith":
        case "EndsWith":
        case "Equals":
          return `${filter.property} != null and ${filter.property}.ToLower().${filter.operator}("${filter.value}")`;
        case "NotContains":
          return `(${filter.property} = null or not ${filter.property}.ToLower().Contains("${filter.value}"))`;

        /* Numbers and dates */

        case "<":
        case "<=":
        case "=":
        case ">=":
        case ">":
          return `${filter.property} ${filter.operator} ${filter.value}`;

        /* Numbers */

        case "!=":
          return `${filter.property} ${filter.operator} ${filter.value}`;

        /* Booleans */

        case "= true":
        case "!= true":
          return `${filter.property} ${filter.operator}`;
        default:
          console.dir("The type you want to filter is not implemented yet. Please contact the developer to get this fixed.");
          if (window.location.href.indexOf("/users") != -1) {
            return `GivenName != null and GivenName.ToLower().Contains("${filter.value}") or FamilyName != null and FamilyName.ToLower().Contains("${filter.value}") or Email != null and Email.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/groups") != -1) {
            return `Name != null and Name.ToLower().Contains("${filter.value}") or Description != null and Description.ToLower().Contains("${filter.value}") or CreatorType != null and CreatorType.ToLower().Contains("${filter.value}") or OwnerId != null and OwnerId.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/invitations") != -1) {
            return `Email != null and Email.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/licenses") != -1) {
            return `Name != null and Name.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/optinentries") != -1) {
            return `Title != null and Title.ToLower().Contains("${filter.value}") or TitleTranslationId != null and TitleTranslationId.ToLower().Contains("${filter.value}") or TextTranslationId != null and TextTranslationId.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/permissions") != -1) {
            return `Name != null and Name.ToLower().Contains("${filter.value}") or Value != null and Value.ToLower().Contains("${filter.value}") or CreatorType != null and CreatorType.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/languages") != -1) {
            return `DisplayName != null and DisplayName.ToLower().Contains("${filter.value}") or Code != null and Code.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/translationentries") != -1) {
            return `Category != null and Category.ToLower().Contains("${filter.value}") or Value != null and Value.ToLower().Contains("${filter.value}") or Comment != null and Comment.ToLower().Contains("${filter.value}") or TranslationId != null and TranslationId.ToLower().Contains("${filter.value}") or Language != null and Language.DisplayName.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/contentpolicies") != -1) {
            return `Name != null and Name.ToLower().Contains("${filter.value}") or Description != null and Description.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/categories") != -1) {
            return `Name != null and Name.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/showrooms") != -1) {
            return `Name != null and Name.ToLower().Contains("${filter.value}") or Description != null and Description.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/products") != -1) {
            return `Name != null and Name.ToLower().Contains("${filter.value}") or Description != null and Description.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/tags") != -1) {
            return `Name != null and Name.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/weblinks") != -1) {
            return `Name != null and Name.ToLower().Contains("${filter.value}") or Url != null and Url.ToLower().Contains("${filter.value}")`;
          }
          if (window.location.href.indexOf("/vishowcontentfiles") != -1) {
            return `DisplayName != null and DisplayName.ToLower().Contains("${filter.value}") and Type != 7 and Type != 8 and Type != 9 or Name != null and Name.ToLower().Contains("${filter.value}") and Type != 7 and Type != 8 and Type != 9`;
          }
      }
    }
  });
  const str = flat.join(" and ");
  return encodeURI(str);
};
exports.mapFiltersToString = mapFiltersToString;
const mapSortingParamsToString = sortParams => {
  const flat = [];
  for (const object of sortParams) {
    flat.push(`${object.column} ${object.order}`);
  }
  const str = flat.join(",");
  return encodeURI(str);
};
exports.mapSortingParamsToString = mapSortingParamsToString;
const formatFilesize = (data, input, format, precision = 2) => {
  switch (format) {
    case "MB":
      switch (input) {
        case "Byte":
          return (data / (1024 * 1024)).toFixed(precision);
        default:
          return (data / (1024 * 1024)).toFixed(precision);
        // byte to mb
      }
    case "GB":
      switch (input) {
        case "Byte":
          return (data / (1024 * 1024 * 1024)).toFixed(precision);
        default:
          return (data / (1024 * 1024 * 1024)).toFixed(precision);
        // byte to gb
      }
    default:
      return (data / (1024 * 1024 * 1024)).toFixed(2);
    // byte to gb
  }
};
exports.formatFilesize = formatFilesize;
const validateEmail = string => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(string).toLowerCase());
};
exports.validateEmail = validateEmail;
const parseParamShorthands = params => {
  Object.entries(params).map(([key, value]) => {
    switch (key) {
      case "startDate":
      case "endDate":
        switch (value) {
          case "startOfMonth":
            {
              const date = (0, _moment.default)().startOf("month").toISOString();
              params = {
                ...params,
                [key]: date
              };
            }
        }
    }
  });
  return params;
};
exports.parseParamShorthands = parseParamShorthands;
const mapShorthandToReadable = shorthand => {
  switch (shorthand) {
    case "startOfMonth":
      return "first of month";
  }
};
exports.mapShorthandToReadable = mapShorthandToReadable;
const parseShorthandToDate = shorthand => {
  switch (shorthand) {
    case "startOfMonth":
      return (0, _moment.default)().startOf("month").toString();
  }
};
exports.parseShorthandToDate = parseShorthandToDate;
const debounce = (func, wait, immediate) => {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
exports.debounce = debounce;
const isValidJson = string => {
  try {
    JSON.parse(string);
  } catch (e) {
    return false;
  }
  return true;
};
exports.isValidJson = isValidJson;
const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
exports.getRandomInt = getRandomInt;
const capitalize = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
exports.capitalize = capitalize;
class Csv {
  parseLine(text) {
    const regex = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
    let arr = [];
    text.replace(regex, (m0, m1, m2, m3) => {
      if (m1 !== undefined) {
        arr.push(m1.replace(/\\'/g, "'"));
      } else if (m2 !== undefined) {
        arr.push(m2.replace(/\\"/g, '"'));
      } else if (m3 !== undefined) {
        arr.push(m3);
      }
      return "";
    });
    if (/,\s*$/.test(text)) {
      arr.push("");
    }
    return arr;
  }
  zipObject(props, values) {
    return props.reduce((prev, prop, i) => {
      prev[prop] = values[i];
      return prev;
    }, {});
  }
  parse(csv) {
    let [properties, ...data] = csv.split("\n").map(this.parseLine);
    return data.map(line => this.zipObject(properties, line));
  }
  serialize(obj) {
    let fields = Object.keys(obj[0]);
    let csv = obj.map(row => fields.map(fieldName => typeof row[fieldName] === "object" ? `"${JSON.stringify(row[fieldName]).replace(/"/g, '""')}"` : row[fieldName] || ""));
    return [fields, ...csv].join("\n");
  }
}
exports.Csv = Csv;
const formatDurationToASP = duration => {
  return `${Math.floor(duration.asDays())}.${(0, _moment.default)(duration._data).format("HH:mm:ss")}`;
};
exports.formatDurationToASP = formatDurationToASP;